import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/JwtService";
import { number } from "yup";
/**
 * @description service to call HTTP request via Axios
 */
class rotService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        rotService.vueInstance = app;
        if (!rotService.vueInstance.axios)
            rotService.vueInstance.use(VueAxios, axios);
        rotService.BaseUrl = import.meta.env.VITE_ROT_URL;
    }
    /**
     * @description set the default HTTP request headers
    */
    static setHeader() {
        rotService.vueInstance.axios.defaults.headers.common["Authorization"] = "Bearer " + JwtService.getToken();
        rotService.vueInstance.axios.defaults.headers.common["Accept"] =
            "application/json";
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        return rotService.vueInstance.axios.get(`${rotService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = "") {
        return rotService.vueInstance.axios.get(`${rotService.BaseUrl}/${resource}/${slug}`);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static getStream(resource, slug = "") {
        return rotService.vueInstance.axios.get(`${rotService.BaseUrl}/${resource}/${slug}`, {
            responseType: 'stream'
        });
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return rotService.vueInstance.axios.post(`${rotService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description Método para enviar arquivos (planilhas) como FormData
     * @param resource: string
     * @param formData: FormData
     * @returns Promise<AxiosResponse>
     */
    static postFile(resource, formData, params) {
        let header = '';
        if (params) {
            header = Object.keys(params).reduce((acc, curr, index) => {
                if (index == 0)
                    acc += `?${curr}=${params[curr]}`;
                else
                    acc += `&${curr}=${params[curr]}`;
                return acc;
            }, '');
        }
        return rotService.vueInstance.axios.post(`${rotService.BaseUrl}/${resource}${header}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data' // Cabeçalho necessário para envio de arquivos
            }
        });
    }
    static getFile(resource, slug = "") {
        return rotService.vueInstance.axios.get(`${rotService.BaseUrl}/${resource}/${slug}`, {
            responseType: 'blob', // Isso garante que o conteúdo retornado seja tratado como arquivo binário
        });
    }
    /**
    * @description Send the PUT HTTP request
    * @param resource: string
    * @param params: AxiosRequestConfig
    * @returns Promise<AxiosResponse>
    */
    static put(resource, params) {
        return rotService.vueInstance.axios.put(`${rotService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the DELETE HTTP request
    * @param resource: string
    * @param slug: number
    * @returns Promise<AxiosResponse>
    */
    static delete(resource, slug = number) {
        return rotService.vueInstance.axios.delete(`${rotService.BaseUrl}/${resource}/${slug}`);
    }
}
export default rotService;
//********** COMENTÁRIO GERADO EM: 28/07/2025 09:42:31 **********
//
//import { App } from "vue";
//import axios from "axios";
//import VueAxios from "vue-axios";
//import JwtService from "@/core/services/JwtService";
//import { AxiosResponse, AxiosRequestConfig } from "axios";
//import { number } from "yup";
//
///**
// * @description service to call HTTP request via Axios
// */
//class rotService {
//    /**
//     * @description property to share vue instance
//     */
//    public static vueInstance: App;
//    private static BaseUrl;
//
//    /**
//     * @description initialize vue axios
//     */
//    public static init(app: App<Element>){
//        rotService.vueInstance = app;
//        rotService.vueInstance.use(VueAxios, axios);
//        //rotService.vueInstance.axios.defaults.baseURL = import.meta.env.VITE_rot_URL;
//        rotService.BaseUrl = import.meta.env.VITE_ROT_URL;
//    }
//
//    /**
//     * @description set the default HTTP request headers
//    */
//    public static setHeader() : void {
//        rotService.vueInstance.axios.defaults.headers.common[
//            "Authorization"
//        ] = "Bearer " + JwtService.getToken();
//		rotService.vueInstance.axios.defaults.headers.common["Accept"] =
//            "application/json";
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static query(
//		resource: string,
//		params: AxiosRequestConfig
//
//    ) : Promise<AxiosResponse> {
//        return rotService.vueInstance.axios.get(`${rotService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param slug: string
//     * @returns Promise<AxiosResponse>
//     */
//    public static get(
//        resource: string,
//        slug = "" as string
//    ): Promise<AxiosResponse> {
//        return rotService.vueInstance.axios.get(`${rotService.BaseUrl}/${resource}/${slug}`);
//    }
//
//	/**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param slug: string
//     * @returns Promise<AxiosResponse>
//     */
//    public static getStream(
//        resource: string,
//        slug = "" as string
//    ): Promise<AxiosResponse> {
//        return rotService.vueInstance.axios.get(`${rotService.BaseUrl}/${resource}/${slug}`, {
//            responseType: 'stream'
//        });
//    }
//
//    /**
//     * @description set the POST HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static post(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return rotService.vueInstance.axios.post(`${rotService.BaseUrl}/${resource}`, params);
//    }
//
//	/**
//     * @description Método para enviar arquivos (planilhas) como FormData
//     * @param resource: string
//     * @param formData: FormData
//     * @returns Promise<AxiosResponse>
//     */
//    public static postFile(resource: string, formData: FormData, params?: any): Promise<AxiosResponse> {
//        let header = ''
//        if (params) {
//            header = Object.keys(params).reduce((acc: any, curr: any, index: number) => {
//                if (index == 0)
//                    acc += `?${curr}=${params[curr]}`
//                else
//                    acc += `&${curr}=${params[curr]}`
//
//                return acc
//            }, '')
//        }
//        return rotService.vueInstance.axios.post(`${rotService.BaseUrl}/${resource}${header}`, formData, {
//            headers: {
//                'Content-Type': 'multipart/form-data' // Cabeçalho necessário para envio de arquivos
//            }
//        });
//    }
//
//    public static getFile(resource: string, slug = ""): Promise<AxiosResponse> {
//        return rotService.vueInstance.axios.get(`${rotService.BaseUrl}/${resource}/${slug}`, {
//            responseType: 'blob', // Isso garante que o conteúdo retornado seja tratado como arquivo binário
//        });
//    }
//
//    /**
//    * @description Send the PUT HTTP request
//    * @param resource: string
//    * @param params: AxiosRequestConfig
//    * @returns Promise<AxiosResponse>
//    */
//    public static put(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return rotService.vueInstance.axios.put(`${rotService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the DELETE HTTP request
//    * @param resource: string
//    * @param slug: number
//    * @returns Promise<AxiosResponse>
//    */
//    public static delete(
//        resource: string,
//        slug = number
//    ): Promise<AxiosResponse> {
//        return rotService.vueInstance.axios.delete(`${rotService.BaseUrl}/${resource}/${slug}`);
//    }
//
//
//}
//
//export default rotService;
//
//
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=rotService.js.map